<template>
  <div>

    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-6">
        <h4>Filters:</h4>
      </div>
      <div class="col-md-6">
        <button style="margin-left: 10px;" type="button" class="btn btn-primary float-right" @click="clearFilter">Clear All</button>
      </div>
    </div>

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-md-6">
        <div>
          By date:
        </div>

        <date-picker :lang="lang" v-model="start_date" valueType="format" :first-day-of-week="1"></date-picker> to
        <date-picker :lang="lang" v-model="end_date" valueType="format" :first-day-of-week="1"></date-picker> &nbsp;&nbsp;
        <button type="button" class="btn btn-danger" @click="getVoucherApprovalsData">Filter</button>

      </div>
      <div class="col-md-3">
        <div>
          By Status:
        </div>
        <select class="form-control" v-model="status" @change="getVoucherApprovalsData">
          <option value="all"> All </option>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
      </div>
    </div>

    <br/>

    <div style="overflow-x: scroll;">
      <b-table striped hover :items="voucherApprovals" :fields="columns">

        <template v-slot:cell(customer)="data">
          <a style="text-decoration: underline; font-weight: bolder;" :href="'/apps/customer/'+data.value.id" v-if="data.value">
            {{ data.value.name }}<br/>
            <small>{{ data.value.mobileNumber }}</small>
          </a>
        </template>

        <template v-slot:cell(voucherCode)="data">
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(outlet)="data">
          <span v-if="data.value">
            {{ data.value.name }}<br/>
            <small>{{ data.value.shopNo }}</small>
          </span>
        </template>

        <template v-slot:cell(amount)="data">
          <span>KES. {{ data.value | number('0,0.00') }}</span>
        </template>

        <template v-slot:cell(voucherType)="data">
          <span class="badge badge-info">{{ data.value }}</span>
        </template>

        <template v-slot:cell(initiatedBy)="data">
          <span v-if="data.value">{{ data.value.name }}</span>
        </template>

        <template v-slot:cell(approvedBy)="data">
          <span v-if="data.value">{{ data.value.name }}</span>
        </template>

        <template v-slot:cell(status)="data">
          <span class="badge badge-warning" v-if="data.value == 'PENDING'">
            Pending
          </span>
          <span class="badge badge-success" v-else-if="data.value == 'APPROVED'">
            Approved
          </span>
          <span class="badge badge-danger" v-else>
            Rejected
          </span>
        </template>

        <template v-slot:cell(created)="data">
          {{ data.value }}
        </template>

        <template v-slot:cell(approvedOn)="data">
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(options)="data">
          <b-dropdown text="options">
            <b-dropdown-item href="#" @click="viewVoucherDetails(data.item)">View Details</b-dropdown-item>
            <b-dropdown-item href="#" v-if="data.item.status == 'PENDING'" @click="openApprovalModal(data.item, 'APPROVED')">Approve</b-dropdown-item>
            <b-dropdown-item href="#" v-if="data.item.status == 'PENDING'" @click="openApprovalModal(data.item, 'REJECTED')">Reject</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-md-12">
        <nav aria-label="Page navigation float-right" style="margin-top: 20px;">
          <ul class="pagination justify-content-center">
            <li v-if="pagination.current_page > 1" class="page-item"><a @click.prevent="changePage(pagination.current_page - 1)" class="page-link" href="#">Previous</a></li>
            <li v-for="page in pagesNumber"
                v-bind:class="[ page == isActived ? 'active' : '']" class="page-item"><a @click.prevent="changePage(page - 1)" class="page-link" href="#">{{ page }}</a></li>
            <li v-if="pagination.current_page < pagination.last_page" class="page-item"><a @click.prevent="changePage(pagination.current_page + 1)" class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Voucher Details Modal -->
    <b-modal id="voucher-details" :title="'Voucher Redemption Details'" size="lg" centered>
      <div v-if="selectedVoucherApproval">
        <b-row>
          <b-col cols="6">
            <h5>Customer Information</h5>
            <p><strong>Name:</strong> {{ selectedVoucherApproval.customer ? selectedVoucherApproval.customer.name : '-' }}</p>
            <p><strong>Phone:</strong> {{ selectedVoucherApproval.customer ? selectedVoucherApproval.customer.mobileNumber : '-' }}</p>
            <p><strong>Loyalty ID:</strong> {{ selectedVoucherApproval.customer ? selectedVoucherApproval.customer.loyaltyId : '-' }}</p>
            <p><strong>Email:</strong> {{ selectedVoucherApproval.customer ? selectedVoucherApproval.customer.email : '-' }}</p>
          </b-col>
          <b-col cols="6">
            <h5>Outlet Information</h5>
            <p><strong>Name:</strong> {{ selectedVoucherApproval.outlet ? selectedVoucherApproval.outlet.name : '-' }}</p>
            <p><strong>Shop No:</strong> {{ selectedVoucherApproval.outlet ? selectedVoucherApproval.outlet.shopNo : '-' }}</p>
            <p><strong>Phone:</strong> {{ selectedVoucherApproval.outlet ? selectedVoucherApproval.outlet.phoneNumber : '-' }}</p>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col cols="12">
            <h5>Voucher Redemption Details</h5>
            <p><strong>Voucher Code:</strong> {{ selectedVoucherApproval.voucherCode }}</p>
            <p><strong>Amount:</strong> KES. {{ selectedVoucherApproval.amount | number('0,0.00') }}</p>
            <p><strong>Voucher Type:</strong> <span class="badge badge-info">{{ selectedVoucherApproval.voucherType }}</span></p>
            <p><strong>Status:</strong> <span :class="{'badge badge-warning': selectedVoucherApproval.status == 'PENDING', 'badge badge-success': selectedVoucherApproval.status == 'APPROVED', 'badge badge-danger': selectedVoucherApproval.status == 'REJECTED'}">{{ selectedVoucherApproval.status }}</span></p>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col cols="12">
            <h5>Additional Information</h5>
            <p><strong>Initiated By:</strong> {{ selectedVoucherApproval.initiatedBy ? selectedVoucherApproval.initiatedBy.name : '-' }}</p>
            <p><strong>Created:</strong> {{ selectedVoucherApproval.created }}</p>
            <p v-if="selectedVoucherApproval.approvedBy"><strong>Approved By:</strong> {{ selectedVoucherApproval.approvedBy.name }}</p>
            <p v-if="selectedVoucherApproval.approvedOn"><strong>Approved On:</strong> {{ selectedVoucherApproval.approvedOn }}</p>
            <p v-if="selectedVoucherApproval.reason"><strong>Reason:</strong><br/>{{ selectedVoucherApproval.reason }}</p>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('voucher-details')">Close</b-button>
      </template>
    </b-modal>

    <!-- Approval/Rejection Modal -->
    <b-modal id="approval-modal-voucher" :title="approvalAction == 'APPROVED' ? 'Approve Voucher Redemption' : 'Reject Voucher Redemption'" @ok="processApproval" centered>
      <form action="#" class="form-horizontal" method="post">
        <div class="form-body">
          <div class="row">
            <div class="col-md-12">
              <p v-if="selectedVoucherApproval">
                Are you sure you want to <strong>{{ approvalAction == 'APPROVED' ? 'approve' : 'reject' }}</strong> this voucher redemption of
                <strong>KES. {{ selectedVoucherApproval.amount | number('0,0.00') }}</strong>
                by <strong>{{ selectedVoucherApproval.customer ? selectedVoucherApproval.customer.name : '' }}</strong>
                at <strong>{{ selectedVoucherApproval.outlet ? selectedVoucherApproval.outlet.name : '' }}</strong>?
              </p>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      pagination: {
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 0
      },
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      offset: 4,
      columns: [
        {
          key: 'customer',
          label: 'Customer',
          sortable: false
        },
        {
          key: 'voucherCode',
          label: 'Voucher Code',
          sortable: false
        },
        {
          key: 'outlet',
          label: 'Outlet',
          sortable: false
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: false
        },
        {
          key: 'voucherType',
          label: 'Voucher Type',
          sortable: false
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'initiatedBy',
          label: 'Initiated By',
          sortable: false
        },
        {
          key: 'created',
          label: 'Created',
          sortable: false
        },
        {
          key: 'approvedBy',
          label: 'Approved By',
          sortable: false
        },
        {
          key: 'approvedOn',
          label: 'Approved On',
          sortable: false
        },
        {
          key: 'options',
          label: 'Options',
          sortable: false
        }
      ],
      voucherApprovals: [],
      start_date: "all",
      end_date: "all",
      status: "all",
      selectedVoucherApproval: null,
      approvalAction: ''
    };
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page + 1;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
    role() {
      return localStorage.getItem("role");
    }
  },
  components: {
    Loading,
    DatePicker
  },
  mounted() {
    this.getVoucherApprovalsData();
  },
  methods: {
    ...mapActions(["getVoucherRedemptionApprovals", "approveVoucherRedemption"]),

    viewVoucherDetails(voucherApproval) {
      this.selectedVoucherApproval = voucherApproval;
      this.$bvModal.show("voucher-details");
    },

    openApprovalModal(voucherApproval, action) {
      this.selectedVoucherApproval = voucherApproval;
      this.approvalAction = action;
      this.$bvModal.show("approval-modal-voucher");
    },

    processApproval() {
      let self = this;

      this.isLoading = true;

      const payload = {
        id: this.selectedVoucherApproval.id,
        status: this.approvalAction
      };

      console.log('Approving/Rejecting voucher redemption with payload:', payload);

      this.approveVoucherRedemption(payload)
        .then(function (response) {
          console.log('Approval response:', response);
          self.isLoading = false;

          self.$bvToast.toast(
            `Voucher redemption ${self.approvalAction == 'APPROVED' ? 'approved' : 'rejected'} successfully`,
            {
              title: 'Success',
              variant: 'success',
              autoHideDelay: 5000,
              appendToast: false
            }
          );

          self.getVoucherApprovalsData();
          self.$bvModal.hide("approval-modal-voucher");
        })
        .catch(function (error) {
          console.error('Approval error:', error);
          self.isLoading = false;

          let errorMessage = 'An error occurred';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          self.$bvToast.toast(errorMessage, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: false
          });
        });
    },

    changePage: function (page) {
      this.pagination.current_page = page;
      this.getVoucherApprovalsData();
    },

    getVoucherApprovalsData() {
      let self = this;

      this.isLoading = true;

      this.getVoucherRedemptionApprovals({
        page: this.pagination.current_page,
        size: 10,
        startDate: this.start_date,
        endDate: this.end_date,
        status: this.status,
        outletId: 0
      })
        .then(function (response) {
          self.isLoading = false;

          // Map the response to extract necessary fields for table display
          self.voucherApprovals = response.content.map(item => {
            // Get customer from customerGift or institutionGiftVoucher
            let customer = null;
            let voucherCode = null;

            if (item.customerGift) {
              customer = item.customerGift.recipient || item.customerGift.boughtBy;
              voucherCode = item.customerGift.voucherCode;
            } else if (item.institutionGiftVoucher) {
              customer = item.institutionGiftVoucher.recipient;
              voucherCode = item.institutionGiftVoucher.voucherCode;
            }

            return {
              ...item,
              customer: customer,
              voucherCode: voucherCode
            };
          });

          self.pagination.current_page = response.number;
          self.pagination.total = response.totalElements;
          self.pagination.per_page = response.numberOfElements;
          self.pagination.from = response.pageable.offset + 1;
          self.pagination.to = response.pageable.pageSize;
          self.pagination.last_page = response.totalPages;
        })
        .catch(function (error) {
          self.isLoading = false;

          if (typeof error.response !== "undefined") {
            if (error.response.status == 401) {
              location.replace("/login");
            }
          }
        });
    },

    clearFilter() {
      this.start_date = "all";
      this.end_date = "all";
      this.status = "all";
      this.getVoucherApprovalsData();
    }
  }
};
</script>

<style scoped>
table tr th {
  padding-top: 10px;
  padding-bottom: 10px;
}

table td {
  padding: 10px;
}

label {
  font-size: 14px;
}
</style>
